import InfoTooltip from '../../components/InfoTooltip';
import './NotificationHeader.scss';

import React from 'react';

export type NotificationHeaderProps = {
  isAdmin: boolean;
};

export default function NotificationHeader(props: NotificationHeaderProps) {
  return (
    <div className="notification-header">
      <div className="title">Notifications</div>
      <InfoTooltip
        message={
          <>
            Your unread notifications display until you read them. Once read, your notifications remain for 14 days.
            {props.isAdmin && (
              <>
                <br />
                <a href="/notifications">Manage notification settings</a>
              </>
            )}
          </>
        }
        size={'tiny'}
        color="grey"
        on="hover"
        hoverable={true}
      />
    </div>
  );
}
